import { FC, JSX } from "react";
import {
  Box,
  Card,
  Container,
  Flex,
  Grid,
  Heading,
  Text,
} from "@radix-ui/themes";
import SONY from "@/assets/brands/Sony_black.webp";
import TCL from "@/assets/brands/TCL_black.webp";
import SAMSUNG from "@/assets/brands/Samsung_black.webp";
import LENOVO from "@/assets/brands/Lenovo_black.webp";
import PHILIPS from "@/assets/brands/Philips_black.webp";

const HomePage: FC = (): JSX.Element => {
  return (
    <>
      <Box
        style={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
          backgroundColor: "var(--accent-3)",
        }}
        pt="9"
        position="relative"
        maxWidth="100%"
      >
        <Flex direction="column" justify="end" style={{ height: "100%" }}>
          <Container px={{ initial: "4", lg: "0" }} pb="5" height="100%">
            <Flex
              gap="1"
              direction="column"
              wrap="wrap"
              height="100%"
              justify="end"
            >
              <Heading align="center" as="h1" size="8">
                Become a Brand Ambassador in the Gaming Industry
              </Heading>
              <Card style={{ padding: "0" }}>
                <Grid columns={{ initial: "1", lg: "3" }} gap="0">
                  <Box px="5" py="8">
                    <Flex direction="column" gap="2" align="center">
                      <Heading as="h2" size="5">
                        Connect With Top Global Brands
                      </Heading>
                      <Text as="p" align="center">
                        Access exclusive opportunities with international brands
                        seeking talented promoters. Our platform partners with
                        industry leaders to bring you premium assignments at
                        expos and events.
                      </Text>
                    </Flex>
                  </Box>

                  <Box
                    px="5"
                    py="8"
                    style={{
                      border: "1px solid var(--accent-4)",
                    }}
                  >
                    <Flex direction="column" gap="2" align="center">
                      <Heading as="h2" size="5">
                        Work On Your Terms
                      </Heading>
                      <Text as="p" align="center">
                        Choose projects that match your schedule, skills, and
                        interests. Find jobs based on your availability,
                        location preferences, and brands for opportunities that
                        fit your lifestyle.
                      </Text>
                    </Flex>
                  </Box>

                  <Box px="5" py="8">
                    <Flex direction="column" gap="2" align="center">
                      <Heading as="h2" size="5">
                        Build Your Promotional Career
                      </Heading>
                      <Text as="p" align="center">
                        Develop your skills and expand your professional
                        network. Gain valuable experience, collect performance
                        reviews, and showcase your experience to advance your
                        career.
                      </Text>
                    </Flex>
                  </Box>
                </Grid>
              </Card>
            </Flex>
          </Container>
        </Flex>
      </Box>
      <Container px={{ initial: "4", lg: "0" }} pt="9">
        <Flex
          justify={{ initial: "center", lg: "between" }}
          direction={{ initial: "column", lg: "row" }}
          gap="8"
        >
          <Flex align="center" justify="center">
            <img src={SONY} alt="Sony" />
          </Flex>
          <Flex align="center" justify="center">
            <img src={SAMSUNG} alt="Samsung" />
          </Flex>
          <Flex align="center" justify="center">
            <img src={TCL} alt="TCL" />
          </Flex>
          <Flex align="center" justify="center">
            <img src={LENOVO} alt="Lenovo" />
          </Flex>
          <Flex align="center" justify="center">
            <img src={PHILIPS} alt="Philips" />
          </Flex>
        </Flex>
      </Container>
    </>
  );
};

export default HomePage;
